import { render, staticRenderFns } from "./W0080V0001.vue?vue&type=template&id=af7d2b8e&scoped=true&"
import script from "./W0080V0001.vue?vue&type=script&lang=js&"
export * from "./W0080V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0080V0001.vue?vue&type=style&index=0&id=af7d2b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7d2b8e",
  null
  
)

export default component.exports